export default function IconDownload() {
  return (
    <svg
      id="icon_download"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Caminho_4325"
        data-name="Caminho 4325"
        d="M0,0H24V24H0Z"
        fill="none"
      />
      <path
        id="Caminho_4326"
        data-name="Caminho 4326"
        d="M12.414,5H21a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3h7.414ZM4,5V19H20V7H11.586l-2-2Zm9,8h3l-4,4L8,13h3V9h2Z"
        fill="#c45151"
      />
    </svg>
  );
}
